import React from "react";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";
import SEO from "../components/SEO";
import styled from "styled-components";
import {
  FaHandshake as Handshake,
  FaBuilding as Building2,
  FaBalanceScale as Scale,
  FaShieldAlt as ShieldCheck,
  FaBriefcase as BriefcaseBusiness,
} from "react-icons/fa";

const CLIENTS = [
  {
    name: "National Bank of Kenya",
    icon: Building2,
  },
  {
    name: "Robson Harris Advocates LLP",
    icon: Scale,
  },
  {
    name: "Omondi & Company Advocates",
    icon: Scale,
  },
  {
    name: "Christine Oraro and Company Advocates",
    icon: Scale,
  },
  {
    name: "Modi & Co. Advocates",
    icon: Scale,
  },
  {
    name: "Ochanda Ogundo and Co. Advocates",
    icon: Scale,
  },
  {
    name: "Okenyo Omwasa & Co. Advocates",
    icon: Scale,
  },
  {
    name: "Harmony Insurance Brokers",
    icon: ShieldCheck,
  },
  {
    name: "Red Bus Services",
    icon: BriefcaseBusiness,
  },
  {
    name: "Probity Larhmas Loss Assessors",
    icon: ShieldCheck,
  },
  {
    name: "Oslonbridge Consultancy Services",
    icon: BriefcaseBusiness,
  },
];

export default function Clients() {
    const navigate = useNavigate();
  return (
    <>
      <SEO
        title="Our Clients | Sare Auctioneers"
        description="Discover some of the organizations and business partners that Sare Auctioneers has worked with through professional auctioneering and related services."
      />

      <TopNavbar />

      <Page>
        {/* HERO */}
        <Hero>
          <div className="container">
            <HeroContent>
              <div>
                <p className="eyebrow">OUR CLIENTS</p>

                <h1>
                  Trusted relationships built through professional service.
                </h1>

                <p>
                  At Sare Auctioneers, we value the relationships we build with
                  our clients and business partners. Our commitment to
                  professionalism, accountability and efficient service has
                  enabled us to work with organizations across different
                  sectors.
                </p>
              </div>

              <HeroIcon>
                <Handshake size={90} />
              </HeroIcon>
            </HeroContent>
          </div>
        </Hero>

        <div className="container">
          {/* INTRODUCTION */}
          <IntroSection>
            <p className="eyebrow">OUR BUSINESS RELATIONSHIPS</p>

            <h2>Some of Our Clients</h2>

            <p>
              The following organizations are identified in the Sare
              Auctioneers company profile among some of the firm's clients.
              We appreciate the trust placed in us and remain committed to
              providing professional and reliable auctioneering and related
              services.
            </p>
          </IntroSection>

          {/* CLIENTS */}
          <ClientsGrid>
            {CLIENTS.map((client) => {
              const Icon = client.icon;

              return (
                <ClientCard key={client.name}>
                  <ClientIcon>
                    <Icon size={25} />
                  </ClientIcon>

                  <div>
                    <h3>{client.name}</h3>
                    <span>Client & Business Relationship</span>
                  </div>
                </ClientCard>
              );
            })}
          </ClientsGrid>

          {/* TRUST SECTION */}
          <TrustSection>
            <TrustContent>
              <TrustIcon>
                <Handshake size={30} />
              </TrustIcon>

              <div>
                <p className="eyebrow">OUR COMMITMENT</p>

                <h2>Built on trust and professionalism</h2>

                <p>
                  We understand that auctioneering and asset realization
                  require a high level of professionalism, accountability and
                  attention to detail. Sare Auctioneers continues to build
                  lasting relationships by focusing on efficient service and
                  the needs of our clients and business partners.
                </p>
              </div>
            </TrustContent>
          </TrustSection>

          {/* CTA */}
          <CTA>
            <p className="eyebrow">WORK WITH US</p>

            <h2>Looking for a professional auctioneering partner?</h2>

            <p>
              Whether you require auctioneering, debt collection,
              repossession, court process serving, realization of charged
              securities or private investigation services, our team is ready
              to assist.
            </p>

            <CTAButton
              onClick={() => navigate("/", {
                state: {
                  scrollTo: "contact",
                },
              })}>
              Get in Touch
            </CTAButton>
          </CTA>
        </div>
      </Page>

      <Footer />
    </>
  );
}

/* =========================
   PAGE
========================= */

const Page = styled.main`
  min-height: 70vh;
  color: #3b1718;

  .container {
    width: 100%;
  }

  @media (max-width: 768px) {
    .container {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
`;

/* =========================
   HERO
========================= */

const Hero = styled.section`
  padding: 150px 0 90px;
  background: #f8f6f5;

  @media (max-width: 768px) {
    padding: 120px 0 65px;
  }
`;

const HeroContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 70px;
  align-items: center;

  h1 {
    max-width: 750px;
    margin: 10px 0 25px;
    font-size: 52px;
    line-height: 1.1;
    font-weight: 800;
    color: #3b1718;
  }

  p:not(.eyebrow) {
    max-width: 700px;
    margin: 0;
    color: #5d191a;
    font-size: 18px;
    line-height: 1.8;
  }

  @media (max-width: 850px) {
    grid-template-columns: 1fr;

    h1 {
      font-size: 42px;
    }
  }
`;

const HeroIcon = styled.div`
  width: 260px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;

  background: #3b1718;
  color: #fff;
  border-radius: 50%;

  @media (max-width: 850px) {
    width: 180px;
    height: 180px;
  }
`;

/* =========================
   COMMON
========================= */

const Eyebrow = styled.p`
  color: #8a3638;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
`;

/* =========================
   INTRO
========================= */

const IntroSection = styled.section`
  max-width: 800px;
  margin: 90px auto 50px;
  text-align: center;

  .eyebrow {
    margin-bottom: 10px;
  }

  h2 {
    margin: 0 0 18px;
    font-size: 40px;
    color: #3b1718;
  }

  p:last-child {
    margin: 0;
    color: #6b4a4a;
    line-height: 1.8;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    margin-top: 65px;

    h2 {
      font-size: 34px;
    }
  }
`;

/* =========================
   CLIENTS
========================= */

const ClientsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 100px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ClientCard = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;

  min-height: 115px;
  padding: 25px;

  background: #fff;
  border: 1px solid #eadede;
  border-radius: 10px;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(59, 23, 24, 0.08);
  }

  h3 {
    margin: 0 0 7px;
    color: #3b1718;
    font-size: 16px;
    line-height: 1.4;
  }

  span {
    color: #8a3638;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }
`;

const ClientIcon = styled.div`
  flex-shrink: 0;

  width: 50px;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #f3e4e4;
  color: #8a3638;

  border-radius: 9px;
`;

/* =========================
   TRUST
========================= */

const TrustSection = styled.section`
  padding: 70px 60px;
  margin-bottom: 90px;

  background: #f8f6f5;
  border-radius: 14px;

  @media (max-width: 768px) {
    padding: 45px 25px;
  }
`;

const TrustContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 25px;
  max-width: 900px;
  margin: auto;

  h2 {
    margin: 8px 0 15px;
    font-size: 32px;
    color: #3b1718;
  }

  p:last-child {
    margin: 0;
    color: #6b4a4a;
    line-height: 1.8;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const TrustIcon = styled.div`
  flex-shrink: 0;

  width: 58px;
  height: 58px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #8a3638;
  color: white;

  border-radius: 10px;
`;

/* =========================
   CTA
========================= */

const CTA = styled.section`
  max-width: 850px;
  margin: 0 auto 100px;
  text-align: center;

  h2 {
    margin: 8px 0 18px;
    font-size: 40px;
    color: #3b1718;
  }

  p:not(.eyebrow) {
    max-width: 700px;
    margin: 0 auto 30px;
    color: #6b4a4a;
    line-height: 1.8;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 32px;
    }
  }
`;

const CTAButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 13px 28px;

  background: #8a3638;
  color: white;

  border-radius: 7px;

  font-size: 14px;
  font-weight: 700;
  text-decoration: none;

  transition: background 0.2s ease;

  &:hover {
    background: #3b1718;
  }
`;